import {
     RECEIVE_GET_CASE_TYPES, GET_CASE_TYPES, RECEIVE_CASE_TYPES, FAILED_TO_GET_CASE_TYPES,
    RECEIVE_CASE_TYPE_EDIT, LOGOUT, RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN,
    // RECEIVE_SUB_CASE_TYPES, REQUEST_SUB_CASE_TYPES
} from "../actions/index";
import _ from 'lodash';

const defaultState = {
	cases: [],
	subCases: [],
	fetching: false,
	badFetchResponse: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN: //action that is dispatched when a premium setting is being edited
            {
                let subCases = [];
                _.forEach(action.payload.caseTypes, (item) => {
                    subCases = [...subCases, ...item.subCaseTypes.map(item => {return item} )]
                });
                return {
                    ...state,
                    fetching: false,
                    cases: action.payload.caseTypes,
                    subCases: subCases
                };
            }
        case RECEIVE_CASE_TYPE_EDIT: //action that received the case types in cycle chain for editing existing solicitor group
            {
                let subCases = [];
                _.forEach(action.payload.caseTypes, (item) => {
                    subCases = [...subCases, ...item.subCaseTypes.map(item => {return item} )]
                });
                return {
                    ...state,
                    fetching: false,
                    cases: action.payload.caseTypes,
                    subCases: subCases
                };
            }
		case GET_CASE_TYPES:
			return {
				...state,
                fetching: true
            };
		case RECEIVE_CASE_TYPES:
            let subCases = [];
            _.forEach(action.payload, (item) => {
                subCases = [...subCases, ...item.subCaseTypes.map(item => {return item} )]
			});
            return {
				...state,
                fetching: false,
                cases: action.payload,
                subCases: subCases
			};
		case FAILED_TO_GET_CASE_TYPES:
			return {
				...state,
                fetching: false
            };
		case RECEIVE_GET_CASE_TYPES:
			return {
				...state,
				fetching: false,
				cases: action.payload
			};
		case LOGOUT:
			return {
				...defaultState
			};
		default:
			return state
	}
}